<template>
  <div class="icWrap" :class="{ margTop: index === 1 }">
    <div id="captcha-element"></div>
    <div id="buttonBtn"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  props: ["index"],
  created() {},
  methods: {
    awscFn() {
      const _this = this
      window.initAliyunCaptcha({
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: '1u5l4025',
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: 'embed',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: '#captcha-element',
        // 触发验证码弹窗或无痕验证的元素
        button: '#buttonBtn',
        // 验证码验证通过回调函数
        success: function (captchaVerifyParam) {
          console.log('captchaVerifyParam====', captchaVerifyParam)
          _this.$emit('update:seleced', captchaVerifyParam)
          // 入参为验签captchaVerifyParam
          // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
          // 2.根据校验结果来进行业务处理
          // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
        },
        // 验证码验证不通过回调函数
        fail: function (result) {
          // 入参为不通过信息
          // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
          console.error(result)
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: function (instance) {
          console.log('instance===', instance)
          _this.captcha = instance
        },
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 120,
          height: 40,
        },
        // ...其他参数，参考initAliyunCaptcha参数说明
      })
      // window.AWSC.use('nc', function(state, module) {
      //   window.nc = module.init({
      //     appkey: 'FFFF0N00000000009B0F',
      //     scene: _this.index === 1 ? 'nc_register' : 'nc_login',
      //     renderTo: _this.index === 1 ? 'ncRegister' : 'ncLogin',
      //     height: 32,
      //     success: function(data) {
      //       if (_this.index === 1) {
      //         _this.ic_register = data
      //       } else {
      //         _this.ic_login = data
      //       }
      //       _this.$emit('update:seleced', data)
      //     },
      //     fail: function(failCode) {
      //       console.log(failCode)
      //     },
      //     error: function(errorCode) {
      //       console.log(errorCode)
      //     }
      //   })
      // })
    }
  },
  mounted() {
    this.awscFn()
  }
}
</script>

<style lang="less" scoped>
.icWrap {
  position: relative;
  width: 280px;
  height: 28px;
  margin: 10px auto;
}
</style>
